import { httpAPI } from "@/api/httpAPI";
import i18n from '@/i18n';

const templateSelect = {
    namespaced: true,
    state: {
        visible: false,
        loading: false,
        resolve: null,        
        title: "Выбор_шаблона",
        data: [],
        templateTypes: [],
        selectedTemplate: null,
        search: null
    },
    mutations: {
        SET_VISIBLE(state, payload) {
            state.visible = payload;
        },
        SET_LOADING(state, payload) {
            state.loading = payload;
        },
        SET_RESOLVE(state, payload) {
            state.resolve = payload;
        },
        SET_TITLE(state, payload){
            state.title = payload ?? "Выбор_шаблона";
        },
        SET_DATA(state, payload) {
            state.data = payload;
        },
        SET_TEMPLATE_TYPES(state, payload) {
            state.templateTypes = payload;
        },
        SET_SELECTED_TEMPLATE(state, payload) {
            state.selectedTemplate = payload;
        },
        SET_SEARCH(state, payload) {
            state.search = payload;
        }
    },
    actions: {
        async open({ commit, dispatch }, options) {
            commit('SET_TITLE', options?.title);
            commit('SET_SEARCH', null);
            commit('SET_SELECTED_TEMPLATE', null);
            commit('SET_VISIBLE', true);
            commit('SET_LOADING', true);
            await dispatch("fetchData");
            commit('SET_LOADING', false);            
            return new Promise((resolve) => { commit('SET_RESOLVE', resolve); });
        },
        async fetchData({ commit, dispatch }) {
            let data = [];
            let documentTemplateTypes = await dispatch('documents/references/getReference', { id: 1041 }, { root: true });
            commit('SET_TEMPLATE_TYPES', JSON.parse(JSON.stringify(documentTemplateTypes)));

            if (documentTemplateTypes?.length > 0) {

                let templatesResponse = await httpAPI({
                    url: `api/document-templates/templates/list-for-select?filter=${JSON.stringify({ OnlyPublished: true, OrderBy: 2, OrderDir: false, Offset: 0 })}`,
                    method: 'GET',
                    headers: { 'isCommon': false },
                });

                if (templatesResponse) {
                    let templates = templatesResponse?.data?.Payload?.data ?? [];

                    data = documentTemplateTypes.reduce((acc, curr, index) => {
                        curr["isGroup"] = true;
                        curr["visible"] = true;
                        curr["collapsed"] = false;
                        curr["sortIndex"] = index.toString();
                        curr["score"] = 0;

                        let children = [{ 
                            id: null,
                            template_name: i18n.t('Типовой_шаблон'),
                            isGroup: false,
                            visible: true,
                            parent: curr.id,
                            sortIndex: index.toString().repeat(2),
                            score: 0
                        }];

                        for (let child of templates.filter(t => t.document_type_id == curr.id)) {
                            child["isGroup"] = false;
                            child["visible"] = true;
                            child["parent"] = curr.id;
                            child["sortIndex"] = index.toString().repeat(2);
                            child["score"] = 0;

                            children.push(child);
                        }

                        return [...acc, curr, ...children];
                    }, []);
                }
            }

            commit('SET_DATA', data);
        },
        async ok({ commit, state, getters }) {
            commit('SET_VISIBLE', false);
            state.resolve({ cancel: false, templateId: getters.getSelectedTemplate.id, documentType: state.templateTypes.find(x => x.id == getters.getSelectedTemplate.parent) });
        },
        async cancel({ commit, state }) {
            commit('SET_VISIBLE', false);
            state.resolve({ cancel: true, message: "Cancelled" });
        },
    },
    getters: {
        isVisible: (s) => s.visible,
        isLoading: (s) => s.loading,
        getTitle: (s) => s.title,
        getData: (s) => s.data,
        getSelectedTemplate: (s) => s.selectedTemplate,
        getSearch: (s) => s.search,
    }
}

export default templateSelect;